import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WalletService } from 'src/app/services/wallet.service';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-userwallet-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss'],
    providers: [ConfirmationService, MessageService]
})

export class AddUserwalletComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    disabled: boolean;
    walletForm: FormGroup;
    errorMessage = '';
    id: string;
    submitted = false;
    isAddMode: boolean;
    pagetitle: string;
    item: any = [];
    userName: any;
    public cash: boolean = true;
    public coins: boolean = false;
    totalCash: any;
    totalDeductedCash: any;
    totalAvailableCash: number;
    totalCoins: any;
    totalDeductedCoin: any;
    totalAvailableCoins: number;
    constructor(
        private walletService: WalletService,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private userWalletService: UserWalletService,
        private userService: UserService,
        private router: Router) { }

    async ngOnInit(): Promise<void> {
        this.pagetitle = 'Load Amount Wallet: ';
        this.id = this.route.snapshot.paramMap.get("id");
        this.walletForm = this.formBuilder.group({
            description: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]*$')]],
            cash: [null, [Validators.required]],
            coins: [],

        });
        this.getUserDetails(this.id)
        this.loadWalletHistory();

        this.isAddMode = !this.id;

        if (!this.isAddMode) {
            this.disabled = true;

            // this.pagetitle = 'Edit Wallet';
        this.userWalletService.getUserWalletDetails(this.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
            this.item = res;
            this.walletForm.controls.description.setValue(this.item['description']);
            this.walletForm.controls.cash.setValue(this.item['amount']);
        });
        }

    }
    onClickCashOrCoin(event) {
        if (event.checked) {
            this.cash = false;
            this.coins = true;
            this.walletForm.get('cash').clearValidators();
            this.walletForm.get('coins').setValidators([Validators.required]);
            this.walletForm.controls.cash.setValue(null);
            this.walletForm.controls.coins.setValue(null);
        } else {
            this.cash = true;
            this.coins = false;
            this.walletForm.get('coins').clearValidators();
            this.walletForm.get('cash').setValidators([Validators.required]);
            this.walletForm.controls.coins.setValue(null);
            this.walletForm.controls.cash.setValue(null);
        }
    }
    // convenience getter for easy access to form fields
    get f() {
        return this.walletForm.controls;
    }



    onSubmit() {
        this.submitted = true;
        // console.log(this.walletForm.value)
        // console.log(this.id)
        if (this.walletForm.invalid) {
            return;
        }
        var walletData = this.walletForm.value;
        let amount = 0; if (this.cash === true) {
            if(this.walletForm.value.cash < 0) {
                this.errorMessage = `Only numbers allowed`;
                return;
            } else {
                this.errorMessage = ``;
            }
            amount = this.walletForm.value.cash;
            walletData.wallettype = 'CASH';
        }
        if (this.coins === true) {
            if(this.walletForm.value.coins < 0) {
                this.errorMessage = `Only numbers allowed`;
                return;
            } else {
                this.errorMessage = ``;
            }
            amount = this.walletForm.value.coins;
            walletData.wallettype = 'COINS';
        }
        walletData.amount = amount;
        walletData.userId = this.id;
        //walletData.amount = this.walletForm.value.cash;
        //walletData.wallettype = 'CASH',
        walletData.action = 'ADD',
            walletData.status = true,
            // walletData. description="Contest Joined",    
            this.userWalletService.addUserWallet(walletData).pipe(takeUntil(this.destroy$)).subscribe(
                async data => {
                    let message = 'Cash Successfully Added to Wallet';
                    if (this.coins === true) {
                        message = 'Coins Successfully Added to Wallet';
                    }
                    this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Success', detail: message });
                    setTimeout(() => {
                        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                        this.router.onSameUrlNavigation = 'reload';
                        this.router.navigate(['/manage/customer/user/wallet/' + this.id]);
                    }, 3000);

                },
                err => {
                    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'Server error, please try again.', life: 6000 });
                }
            )

        // if (this.isAddMode) {
        //     walletData = JSON.stringify(walletData, null, 4);
        //     this.addSeller(walletData);
        // } else {
        //     walletData = JSON.stringify(walletData, null, 4);
        //     this.updateSeller(walletData);
        // }
    }



    addSeller(walletData) {
        this.walletService.addWallet(walletData).pipe(takeUntil(this.destroy$)).subscribe(
            () => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Wallet Added', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/wallet']);
                }, 2000);
            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Wallet failed', life: 6000 });
            })
        );
    }
    updateSeller(walletData) {
        this.walletService.updateWallet(this.id, walletData).pipe(takeUntil(this.destroy$)).subscribe(
            () => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Wallet Updated', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/manage/wallet']);
                }, 2000);
            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Wallet failed', life: 6000 });
            })
        );
    }

    onReset() {
        this.submitted = false;
        this.walletForm.reset();
    }

    backLink() {
        this.router.navigate(['/manage/customer/user/wallet/' + this.id]);
    }
    getUserDetails(id) {
        this.userService.getUserDetails(id).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                this.userName = data.fullName

            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    loadWalletHistory() {
    var query = "?filterByDisable=false&filterByUserid=" + this.id;
    this.userWalletService.getUserWalletList(query).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
            this.totalCash = data.data.totalCash;
            this.totalDeductedCash = data.data.totalDeductedCash;
            this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
            this.totalCoins = data.data.totalCoins;
            this.totalDeductedCoin = data.data.totalDeductedCoin;
            this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        },
        err => {
            this.errorMessage = err.error.message;
        }
    );
}

ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
